import React from "react";
import PropTypes from "prop-types";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close
} from "MODULES/shared/components/Modal";

export default function ConfirmDelete({
  onConfirm,
  open,
  close,
  children,
  message = "Are you sure you want to delete this?"
}) {
  const confirm = () => {
    onConfirm();
    close();
  };

  return (
    <Modal open={open} close={close} dialogClass="modal-sm">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Are You Sure?</h4>
      </Header>
      <Body>
        <div className="alert alert-warning margin-bottom-none">
          <div className="media">
            <div className="media-left">
              <i className="fa fa-lg fa-warning text-warning" />
            </div>
            <div className="media-body">
              {children || (
                <span>
                  <strong>Heads up!</strong> {message}
                </span>
              )}
            </div>
          </div>
        </div>
      </Body>
      <Footer>
        <button type="button" className="btn btn-default" onClick={close}>
          Cancel
        </button>
        <button type="button" className="btn btn-danger" onClick={confirm}>
          <i className="fa fa-fw fa-trash" /> Delete
        </button>
      </Footer>
    </Modal>
  );
}

ConfirmDelete.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  message: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/ConfirmDelete/ConfirmDelete.jsx